import react, { useEffect } from "react";
import ReusableZoneSection from "./ZoneCard";
import firstBg from "./updateImages/firstbg.jpg";
import firstsection1 from "./updateImages/firstsection1.jpg";
import firstsection2 from "./updateImages/firstsection2.jpg";
import secondsectionbg from "./updateImages/secondsectionbg.jpg";
import secondsection1 from "./updateImages/secondsection1.jpg";
import thirdsectionbg from "./updateImages/thirdsectionbg.jpg";
import thirdsection1 from "./updateImages/thirdsection1.jpg";
import thirdsection2 from "./updateImages/thirdsection2.jpg";
import fourthsectionbg from "./updateImages/fourthsectionbg.jpg";
import fourthsection1 from "./updateImages/fourthsection1.jpg";
import fourthsection2 from "./updateImages/fourthsection2.jpg";
import fifthsectionbg from "./updateImages/fifthsectionbg.png";
import fifthsection1 from "./updateImages/fifthsection1.jpg";
import fifthsection2 from "./updateImages/fifthsection2.jpg";
import sixthsectionbg from "./updateImages/sixthsectionbg .jpg";
import sixthsection1 from "./updateImages/sixthsection1.jpg";
import sixthsection2 from "./updateImages/sixthsection2.jpg";
import seventhsectionbg from "./updateImages/seventhsectionbg.jpg";
import seventhsection1 from "./updateImages/seventhsection1.jpg";
import seventhsection2 from "./updateImages/seventhsection2.jpg";
import eightsectionbg from "./updateImages/eightsectionbg.png";
import eightsection1 from "./updateImages/eightsection1.jpg";
import eightsection2 from "./updateImages/eightsection2.jpg";
import ninesectionbg from "./updateImages/ninesectionbg.jpg";
import ninesection1 from "./updateImages/ninesection1.jpg";
import ninesection2 from "./updateImages/ninesection2.jpg";
import tenthsectionbg from "./updateImages/tenthsectionbg.jpg";
import tenthsection1 from "./updateImages/tenthsection1.jpg";
import tenthsection2 from "./updateImages/tenthsection2.jpg";
import eleventhbg from "./updateImages/eleventhsectionbg.jpg";
import eleventh1 from "./updateImages/eleventhsectio1.jpg";
import eleventh2 from "./updateImages/eleventhsection2.jpg";
import twelvebg from "./updateImages/twelvethbg.jpg";
import twelve1 from "./updateImages/twelvesectionfirst.jpg";
import twelve2 from "./updateImages/twelvesectionsecond.jpg";
import { scrollToTop } from "../../utils";

const Zone = () => {
  useEffect(() => {
    scrollToTop();
  }, []);
  const firstSectionActivities = [
    { id: 1, title: "Trampoline Treasure", coins: 2500 },
    { id: 2, title: "Paintball Arena", coins: 3000 },
  ];

  const firstSectionImages = [
    {
      src: firstsection1,
      alt: "Trampoline",
    },
    {
      src: firstsection2,
      alt: "Paintball",
    },
  ];

  const secondSectionActivities = [
    { id: 1, title: "VR Cricket", coins: 2000 },
    { id: 1, title: "Laser Wars", coins: 3000 },
  ];

  const secondSectionImages = [
    {
      src: secondsection1,
      alt: "VR Cricket",
    },
    {
      src: secondsectionbg,
      alt: "Laser wars",
    },
  ];

  const thirdSectionActivities = [
    { id: 1, title: "Low Ropes Challenges", coins: 1500 },
    { id: 1, title: "High Ropes Haven", coins: 1500 },
  ];

  const thirdSectionImages = [
    {
      src: thirdsection1,
      alt: "Low Ropes Challenges",
    },
    {
      src: thirdsection2,
      alt: "High Ropes Haven",
    },
  ];
  const fourthSectionActivities = [
    { id: 1, title: "Sky Cycle", coins: 2500 },
    { id: 1, title: "Giant Swing", coins: 3000 },
  ];

  const fourthSectionImages = [
    {
      src: fourthsection1,
      alt: "Sky Cycle",
    },
    {
      src: fourthsection2,
      alt: "Gaint Swing",
    },
  ];
  const fifthSectionActivities = [
    { id: 1, title: "Rock Climbing", coins: 2000 },
    { id: 1, title: "Zipline Adventure", coins: 2500 },
  ];

  const fifthSectionImages = [
    {
      src: fifthsection1,
      alt: "Rock",
    },
    {
      src: fifthsection2,
      alt: "Zipline",
    },
  ];
  const sixthSectionActivities = [
    { id: 1, title: "Commando Climb", coins: 1000 },
    { id: 1, title: "Meltdown Madness", coins: 1000 },
  ];

  const sixthSectionImages = [
    {
      src: sixthsection2,
      alt: "Commando Climb",
    },
    {
      src: sixthsection1,
      alt: "Meltdown Madness",
    },
  ];

  const seventhSectionActivities = [
    { id: 1, title: "Bucking Bull", coins: 1000 },
    { id: 1, title: "Zorbie Fight", coins: 1000 },
  ];

  const seventhSectionImages = [
    {
      src: seventhsection1,
      alt: "Bucking Bull",
    },
    {
      src: seventhsection2,
      alt: "Zorbie Fight",
    },
  ];

  const eightSectionActivities = [
    { id: 1, title: "Kids Obstacle", coins: 1000 },
    { id: 1, title: "Burma Bridge", coins: 1500 },
  ];

  const eighthSectionImages = [
    {
      src: eightsection1,
      alt: "Kids Obstacle",
    },
    {
      src: eightsection2,
      alt: "Burma Bridge",
    },
  ];
  const nineSectionActivities = [
    { id: 1, title: "Pedal Go Kart", coins: 1000 },
    { id: 1, title: "Rocket Ejector", coins: 2500 },
  ];

  const nineSectionImages = [
    {
      src: ninesection1,
      alt: "Pedal Go Kart",
    },
    {
      src: ninesection2,
      alt: "Rocket Ejector",
    },
  ];
  const tenthSectionActivities = [
    { id: 1, title: "Cyclone Cycle 360", coins: 1000 },
    { id: 1, title: "Gyro Sphere 360", coins: 1500 },
  ];

  const tenthSectionImages = [
    {
      src: tenthsection1,
      alt: "Cyclone Cycle 360",
    },
    {
      src: tenthsection2,
      alt: "Gyro Sphere 360",
    },
  ];
  const elevenSectionActivities = [
    { id: 1, title: "Archery Alley", coins: 1000 },
    { id: 1, title: "Shooter’s Range", coins: 1000 },
  ];

  const elevenSectionImages = [
    {
      src: eleventh1,
      alt: "Archery Alley",
    },
    {
      src: eleventh2,
      alt: "Shooter’s Range",
    },
  ];

  const twelveSectionActivities = [
    { id: 1, title: "Acrade Games", coins: 1500 },
    { id: 1, title: "VR Zone", coins: 1500 },
  ];

  const twelveSectionImages = [
    {
      src: twelve1,
      alt: "Acrade Game",
    },
    {
      src: twelve2,
      alt: "VR Zone",
    },
  ];

  return (
    <>
      {/* first section */}
      <div className="space-y-0">
        <ReusableZoneSection
          backgroundImage={firstBg}
          activities={firstSectionActivities}
          images={firstSectionImages}
          onBookNow={(activityId) =>
            console.log(`Booking activity ${activityId}`)
          }
        />
      </div>
      {/* second section */}
      <div className="space-y-0">
        <ReusableZoneSection
          backgroundImage={secondsectionbg}
          activities={secondSectionActivities}
          images={secondSectionImages}
          onBookNow={(activityId) =>
            console.log(`Booking activity ${activityId}`)
          }
        />
      </div>
      {/* third section */}
      <div className="space-y-0">
        <ReusableZoneSection
          backgroundImage={thirdsectionbg}
          activities={thirdSectionActivities}
          images={thirdSectionImages}
          onBookNow={(activityId) =>
            console.log(`Booking activity ${activityId}`)
          }
        />
      </div>
      {/* fourth section */}
      <div className="space-y-0">
        <ReusableZoneSection
          backgroundImage={fourthsectionbg}
          activities={fourthSectionActivities}
          images={fourthSectionImages}
          onBookNow={(activityId) =>
            console.log(`Booking activity ${activityId}`)
          }
        />
      </div>
      {/* fifth section */}
      <div className="space-y-0">
        <ReusableZoneSection
          backgroundImage={fifthsectionbg}
          activities={fifthSectionActivities}
          images={fifthSectionImages}
          onBookNow={(activityId) =>
            console.log(`Booking activity ${activityId}`)
          }
        />
      </div>
      {/* sixth section */}
      <div className="space-y-0">
        <ReusableZoneSection
          backgroundImage={sixthsectionbg}
          activities={sixthSectionActivities}
          images={sixthSectionImages}
          onBookNow={(activityId) =>
            console.log(`Booking activity ${activityId}`)
          }
        />
      </div>
      {/* seventh section */}
      <div className="space-y-0">
        <ReusableZoneSection
          backgroundImage={seventhsectionbg}
          activities={seventhSectionActivities}
          images={seventhSectionImages}
          onBookNow={(activityId) =>
            console.log(`Booking activity ${activityId}`)
          }
        />
      </div>
      {/* eight section */}
      <div className="space-y-0">
        <ReusableZoneSection
          backgroundImage={eightsectionbg}
          activities={eightSectionActivities}
          images={eighthSectionImages}
          onBookNow={(activityId) =>
            console.log(`Booking activity ${activityId}`)
          }
        />
      </div>
      {/* nine section */}
      <div className="space-y-0">
        <ReusableZoneSection
          backgroundImage={ninesectionbg}
          activities={nineSectionActivities}
          images={nineSectionImages}
          onBookNow={(activityId) =>
            console.log(`Booking activity ${activityId}`)
          }
        />
      </div>
      {/* ten section */}
      <div className="space-y-0">
        <ReusableZoneSection
          backgroundImage={tenthsectionbg}
          activities={tenthSectionActivities}
          images={tenthSectionImages}
          onBookNow={(activityId) =>
            console.log(`Booking activity ${activityId}`)
          }
        />
      </div>
      {/* eleven section */}
      <div className="space-y-0">
        <ReusableZoneSection
          backgroundImage={eleventhbg}
          activities={elevenSectionActivities}
          images={elevenSectionImages}
          onBookNow={(activityId) =>
            console.log(`Booking activity ${activityId}`)
          }
        />
      </div>
      {/* twelve section */}
      <div className="space-y-0">
        <ReusableZoneSection
          backgroundImage={twelvebg}
          activities={twelveSectionActivities}
          images={twelveSectionImages}
          onBookNow={(activityId) =>
            console.log(`Booking activity ${activityId}`)
          }
        />
      </div>
    </>
  );
};

export default Zone;

// const CoinsBox = ({ text, subText }) => (
//   <Box
//     sx={{
//       width: { xs: "150px", md: "210px" },
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       position: "relative",
//     }}
//   >
//     <Box
//       component={"img"}
//       src={MoneyBg}
//       alt="background"
//       sx={{
//         width: { xs: "140px", md: "200px" },
//       }}
//     />
//     <Box
//       sx={{
//         position: "absolute",
//         right: "0px",
//         width: { xs: "100px", md: "140px" },
//       }}
//     >
//       <Typography
//         sx={{
//           color: "white",
//           fontWeight: "600",
//           fontSize: { xs: "12px", md: "16px" },
//           zIndex: "110",
//           textAlign: "center",
//         }}
//       >
//         {text}
//       </Typography>
//       {subText && (
//         <Typography
//           sx={{
//             color: "white",
//             fontWeight: "400",
//             fontSize: { xs: "10px", md: "12px" },
//             zIndex: "110",
//             textAlign: "center",
//           }}
//         >
//           {subText}
//         </Typography>
//       )}
//     </Box>
//   </Box>
// );
